import React from 'react';

import { SvgProps } from './svg.type';

export const DashedLineViolet: React.FC<SvgProps> = (props) => (
    <svg
        width="129"
        height="55"
        viewBox="0 0 129 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0.5 1C23.3333 5.66667 64.8 17.1 128 53.5"
            stroke="url(#paint0_linear_1378:765)"
            strokeWidth="2"
            strokeDasharray="4 4"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1378:765"
                x1="0.502192"
                y1="27.2613"
                x2="141.471"
                y2="3.69593"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#879FC9" />
                <stop offset="1" stopColor="#DCE9E2" />
            </linearGradient>
        </defs>
    </svg>
);
